import styled from 'styled-components'

export const Container = styled.div `
    width: 100%;
    height: 100%;
    video{
        width: 100%;
        height: 100%;
        outline: none;
    }
`